// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3877":"fe336940f98fdfab","4213":"c8ae9df65580a992","6676":"d23fb47b914c672d","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};